export const SAML_REQUEST_PARAM = 'SAMLRequest' as const;
export const SAML_RELAY_STATE_PARAM = 'RelayState' as const;
